import cn from 'classnames'
import * as Input from '@UI/InputNew'
import { useInputNew } from '@UI/InputNew/useInputNew'
import s from './BodyPersonal.module.css'
import { useGetSettings } from '@pages/CoursesCatalog/tabs/CatalogCoursesTab/hooks/getPlatformSettings'
import { DatePicker } from 'antd'
import FieldWrapper from '@pages/Admin/CourseSettings/components/FieldWrapper/FieldWrapper'
import dayjs from 'dayjs'
import NotificationsSettingsButton from '@modals/NotificationsSettings/NotificationsSettingsButton'
import { WorkHoursSchedule } from '@common/WorkHours'
import { EMPLOYEE_FIELD_TYPES } from '@/helpers/employeeProfileFields'
import { getProfileFieldValue } from '@/helpers/profileFields'

export const BodyPersonal = (props) => {
  const { checkSettings } = useGetSettings()
  const isColleague = props.userRole !== 'children'
  const hasTeacherProfileSettings = Array.isArray(props.teacherProfileFields)
  const isTeacherFieldVisible = (fieldId, legacyValue) =>
    props.isEmployee && hasTeacherProfileSettings
      ? props.isTeacherProfileFieldVisible(fieldId)
      : legacyValue
  const isTeacherFieldEditable = (fieldId) =>
    !props.isEmployee ||
    !hasTeacherProfileSettings ||
    props.canEditTeacherProfileField(fieldId)

  const isPhoneNumberShow = isTeacherFieldVisible(
    'phone',
    isColleague
      ? checkSettings('showPhoneColleagues')
      : checkSettings('isShowPhoneChild'),
  )
  const isEmailShow = isTeacherFieldVisible(
    'email',
    isColleague
      ? checkSettings('showEmailColleagues')
      : checkSettings('isShowEmailChild'),
  )
  const isGenderShow = isTeacherFieldVisible(
    'sex',
    isColleague
      ? checkSettings('showGenderColleagues')
      : checkSettings('isShowGenderChild'),
  )
  const isBirthdayShow = isTeacherFieldVisible(
    'birthDate',
    isColleague
      ? checkSettings('showBirthDateColleagues')
      : checkSettings('isShowDateOfBirthChild'),
  )
  const isClassShow = isColleague ? false : checkSettings('isShowClassChild')
  const isPromoCodeShow = isColleague
    ? false
    : checkSettings('isShowPromoChild')
  const isSocialMediaShow = isTeacherFieldVisible(
    'socialLink',
    isColleague
      ? checkSettings('showSocialLinkColleagues')
      : checkSettings('isShowLinkToSocialMediaNetChild'),
  )
  const isCityShow = isTeacherFieldVisible(
    'city',
    isColleague
      ? checkSettings('showCityColleagues')
      : checkSettings('isShowCityChild'),
  )
  const isAboutMeShow = isTeacherFieldVisible(
    'about',
    isColleague
      ? checkSettings('showAboutMeColleagues')
      : checkSettings('isShowAboutMeChild'),
  )
  const showWorkSchedule = isColleague
    ? checkSettings('showWorkScheduleColleagues')
    : false

  return (
    <>
      <div className={cn(s.wrapper, { [s.employeeWrapper]: props.isEmployee })}>
        {!props.isEmployee && (
          <EditInput
            disabled={props.disableFullNameEditing}
            name="name"
            label="ФИО"
            required={true}
            className={s.fio}
            {...props}
          />
        )}
        {isEmailShow && (
          <EditInput
            disabled={
              props.disableEmailEditing || !isTeacherFieldEditable('email')
            }
            name="email"
            label="Электронная почта"
            required={
              props.isEmployee
                ? props.isTeacherProfileFieldRequired('email')
                : true
            }
            {...props}
          />
        )}
        {isPhoneNumberShow && (
          <EditInputPhone
            disabled={
              props.disablePhoneEditing || !isTeacherFieldEditable('phone')
            }
            {...props}
          />
        )}
        {props.isEmployee && isTeacherFieldVisible('login', false) && (
          <EditInput
            name="login"
            label="Логин"
            disabled={!isTeacherFieldEditable('login')}
            {...props}
          />
        )}
        {isGenderShow && (
          <EditInputSex disabled={!isTeacherFieldEditable('sex')} {...props} />
        )}
        {isBirthdayShow && (
          <EditInputDate
            disabled={!isTeacherFieldEditable('birthDate')}
            {...props}
          />
        )}

        {props.isEmployee ? (
          <>
            {isTeacherFieldVisible('education', true) && (
              <EditInput
                name="education"
                label="Образование"
                disabled={!isTeacherFieldEditable('education')}
                {...props}
              />
            )}
            {isTeacherFieldVisible('experience', true) && (
              <EditInput
                name="experience"
                label="Опыт работы"
                disabled={!isTeacherFieldEditable('experience')}
                {...props}
              />
            )}
            {isTeacherFieldVisible('conferenceLink', false) && (
              <EditInput
                name="url_conference"
                label="Ссылка на ВКС"
                disabled={!isTeacherFieldEditable('conferenceLink')}
                {...props}
              />
            )}
            {props.isTelebosIntegrationEnabled && (
              <EditInput
                name="telebos_room_id"
                label="ID комнаты Telebos"
                {...props}
              />
            )}
          </>
        ) : (
          isClassShow && (
            <EditInput
              name="learning_class"
              label="Класс"
              className={s.class}
              {...props}
            />
          )
        )}
        {isSocialMediaShow && (
          <EditInput
            name="link_to_vk"
            label="Ссылка вконтакте"
            disabled={!isTeacherFieldEditable('socialLink')}
            {...props}
          />
        )}
        {isCityShow && (
          <EditInput
            name="city"
            label="Город"
            disabled={!isTeacherFieldEditable('city')}
            {...props}
          />
        )}
        {props.isEmployee ? (
          isTeacherFieldVisible('address', true) && (
            <EditInput
              name="address"
              label="Адрес регистрации"
              disabled={!isTeacherFieldEditable('address')}
              {...props}
            />
          )
        ) : (
          isPromoCodeShow && <PromoCode {...props} />
        )}
        {props.teacherProfileFields
          ?.filter((field) => field.isCustom && field.profile_visible)
          .map((field) => (
            <EditCustomProfileField
              key={field.id}
              field={field}
              disabled={!field.profile_editable}
              {...props}
            />
          ))}
      </div>
      <NotificationsSettingsButton
        userId={props.user?.id}
      />
      {isAboutMeShow && (
        <EditInputAbout
          disabled={!isTeacherFieldEditable('about')}
          {...props}
        />
      )}
      {showWorkSchedule && (
        <div className={s.workHoursWrapper}>
          <EditWorkHours {...props} />
        </div>
      )}
    </>
  )
}

const EditInput = ({
  name,
  label,
  required,
  className,
  disabled,
  ...props
}) => {
  const [bind] = useInputNew({
    name: name,
    value: props.user[name],
    onChange: (e) => props.edit(name, e),
    onError: required ? props.validate.setErrorsList : () => {},
    validate: required ? props.validate.showErrors : false,
    placeholder: label,
    title: label,
  })
  return (
    <Input.InputNew
      disabled={disabled}
      className={cn({ [className]: className })}
      {...bind}
    />
  )
}

const EditInputSex = (props) => {
  const [bind] = useInputNew({
    name: 'sex',
    value: props.user.sex,
    onChange: (e) => props.edit('sex', e),
    placeholder: 'Выбрать',
    title: 'Пол',
    options: [
      { label: 'М', value: 'male' },
      { label: 'Ж', value: 'female' },
    ],
  })
  return (
    <Input.InputSelect
      disabled={props.disabled}
      className={s.sex}
      {...bind}
    />
  )
}

const EditInputDate = (props) => {
  return (
    <FieldWrapper label="Дата рождения" className={s.fieldWrapper}>
      <DatePicker
        className={s.datePicker}
        name={'birth_date'}
        placeholder="Дата рождения"
        value={props.user.birth_date ? dayjs(props.user.birth_date) : null}
        format={'YYYY-MM-DD'}
        disabled={props.disabled}
        onChange={(date, string) => props.edit('birth_date', string)}
      />
    </FieldWrapper>
  )
}

const EditInputPhone = (props) => {
  const [bind] = useInputNew({
    name: 'phone',
    value: props.user.phone,
    onChange: (e) => props.edit('phone', e),
    title: 'Номер телефона',
  })
  return <Input.InputTel disabled={props.disabled} {...bind} />
}

const EditInputAbout = (props) => {
  const [bind] = useInputNew({
    name: 'about',
    value: props.user.about,
    onChange: (e) => props.edit('about', e),
    title: 'О себе',
  })
  return (
    <Input.InputTextarea
      disabled={props.disabled}
      className={s.about}
      {...bind}
    />
  )
}

const EditCustomProfileField = ({ field, disabled, ...props }) => {
  const value = getProfileFieldValue(props.customProfileFieldValues, field) ?? ''
  const [bind] = useInputNew({
    name: field.name,
    value,
    type: field.type === EMPLOYEE_FIELD_TYPES.NUMBER ? 'number' : undefined,
    onChange: (nextValue) => props.editCustomProfileField(field, nextValue),
    placeholder: field.label,
    title: field.label,
    options: (field.value_options ?? []).map((option) => ({
      label: option,
      value: option,
    })),
  })

  if (field.type === EMPLOYEE_FIELD_TYPES.SELECT) {
    return <Input.InputSelect disabled={disabled} {...bind} />
  }

  if (field.type === EMPLOYEE_FIELD_TYPES.DATE) {
    return (
      <FieldWrapper label={field.label} className={s.fieldWrapper}>
        <DatePicker
          className={s.datePicker}
          placeholder={field.label}
          value={value ? dayjs(value) : null}
          format="YYYY-MM-DD"
          disabled={disabled}
          onChange={(date, dateString) =>
            props.editCustomProfileField(field, dateString)
          }
        />
      </FieldWrapper>
    )
  }

  if (field.type === EMPLOYEE_FIELD_TYPES.TEXTAREA) {
    return <Input.InputTextarea disabled={disabled} {...bind} />
  }

  if (field.type === EMPLOYEE_FIELD_TYPES.PHONE) {
    return <Input.InputTel disabled={disabled} {...bind} />
  }

  return <Input.InputNew disabled={disabled} {...bind} />
}

const PromoCode = (props) => {
  const [bind] = useInputNew({
    name: 'promo_code',
    value: props.user.promo_code,
    title: 'Промокод',
  })
  return <Input.InputCopy className={s.promo} {...bind} />
}

const EditWorkHours = (props) => {
  const editable =
    props.settingCard.editMode &&
    !props.isTeacherScheduleModificationRestricted &&
    props.userRole !== 'senior-seminarian'

  return (
    <WorkHoursSchedule
      workHours={props.user.workHours}
      editable={editable}
      onEdit={() => props.setModal('AddWorkHours')}
    />
  )
}
